export const statusColor = (data) => {
  if (typeof data === "string") {
    switch (data.toLowerCase()) {
      case "draft":
        return "Gray-100";
      case "pending":
      case "pending_approval":
        return "Cyan-500";
      case "approved":
      case "active":
        return "Green-150";
      case "rejected":
        return "Red-150";
      case "on_hold":
      case "inactive":
        return "Orange-150";
      case "archived":
        return "Gray-200";
      case "deleted":
        return "Red-150";
      default:
        return "Gray-100";
    }
  }
  return "Gray-100";
};
